import {
  disputeStatus,
  disputeViewSchema,
} from "@redotech/redo-model/disputes/dispute-definition";
import * as z from "zod/v4";

export const getDisputes = {
  name: "getDisputes" as const,
  input: z.object({ statuses: z.array(z.enum(disputeStatus)).optional() }),
  output: z.object({ disputes: z.array(disputeViewSchema) }),
};
